import { Box } from "@mui/material";

function TypingIndicator() {
  return (
    <Box sx={{ display: "flex", gap: 0.5, px: 2, py: 1.5 }}>
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: "grey.400",
            animation: "typingBounce 1.4s infinite ease-in-out",
            animationDelay: `${i * 0.2}s`,
            "@keyframes typingBounce": {
              "0%, 60%, 100%": { transform: "translateY(0)", opacity: 0.4 },
              "30%": { transform: "translateY(-6px)", opacity: 1 },
            },
          }}
        />
      ))}
    </Box>
  );
}

export default TypingIndicator;
